import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import LayerManagementImg from './img/LayerManagement.png'

export default class LayerManagement extends Component {
  render() {
    return (
      <div className="main-window">
      <div className="main-window-title">使用图层管理功能</div>
      <img src={LayerManagementImg} className="main-window-img"></img>
    </div>
    )
  }
}
